import React, { useEffect } from 'react';

import styled from 'styled-components';

import { ESignUpCrmContent, useSignupCrm } from '@aqx-core/common/services/sign-up-crm';
import { signUpCrmViewController } from '@aqx-core/common/services/sign-up-crm/controller';

import SignUpCrmBasic from './basic';
import SignUpCrmComplete from './complete';
import SignUpCrmVerification from './verification';

const SignUpCrmScreen: FCC = () => {
  const { content } = useSignupCrm();
  const getContent = (content: ESignUpCrmContent) => {
    switch (content) {
      case ESignUpCrmContent.COMPLETE:
        return <SignUpCrmComplete />;
      case ESignUpCrmContent.VERIFICATION:
        return <SignUpCrmVerification />;
      case ESignUpCrmContent.BASIC:
      default:
        return <SignUpCrmBasic />;
    }
  };

  useEffect(() => {
    return () => {
      signUpCrmViewController.reset();
    };
  }, []);

  return <StyledContainer>{getContent(content)}</StyledContainer>;
};

export default SignUpCrmScreen;

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;
